import { DatetimeFormat } from '@core/models/common/datetime-format';
import { GlobalSettings } from '@core/models/common/global-settings';
import { Industry } from '@core/models/common/industry';

export interface IGlobalState {
    platforms: {
        web: any;
        ios: any;
        android: any;
    };
    positionColors: string[];
    currencyOptions: any[];
    locales: {label: string, value: string}[]
    industries: Industry[];
    timezones: any[];
    settings: GlobalSettings;
    datetimeFormats: DatetimeFormat[];
}

export function initialGlobalState(): IGlobalState {
    return {
        platforms: {
            web: {},
            ios: {},
            android: {}
        },
        positionColors: [],
        currencyOptions: [],
        locales: [],
        industries: [],
        timezones: [],
        settings: {
            articleLinks: {}
        },
        datetimeFormats: []
    };
}
